import { createApp } from 'vue'
// AG Grid (registrazione moduli community)
import { ModuleRegistry } from 'ag-grid-community';
import { AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

// CSS base AG Grid + tema quartz (necessari per visualizzazione griglia)
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import App from './App.vue'
import '@/assets/scss/tailwind.scss';
import '@/assets/libs/@iconscout/unicons/css/line.css';
import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css';
import  '@/assets/libs/animate.css/animate.min.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import VueSmoothScroll from 'vue3-smooth-scroll'
import '@vuepic/vue-datepicker/dist/main.css';
import router from './router'
import authConfig from './requestHandler/authConfig'
import store from './store'
import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

// Imposta la funzione di navigazione
authConfig.sendToLoginRoute = () => {
    router.push({ name: "auth-login" })
}

const app = createApp(App)
app.use(VueDatePicker)
app.use(VueSmoothScroll)
app.use(ToastPlugin, { position: 'top-right' })
app.use(LoadingPlugin, 
    {
        color: 'red',
    }
)
app.use(router)
app.use(store)
app.use(CkeditorPlugin)
app.mount('#app')
